import React from "react";
import { useAppSelector } from "../../../redux/hooks";
import { selectSelectedLeague, selectSelectedLeagueId } from "../../../redux/slice/selectedLeagueSlice";
import LeagueMatches from "./LeagueMatches";
import LeaguePointsTable from "./LeaguePointsTable";
import LeagueStats from "./LeagueStats";
import "./leagueHome.scss";

/** League home: Matches (every tournament) → Points table → All-time league stats. The league bar above is shared by every league tab. */
const HomePage: React.FC = () => {
  const leagueId = useAppSelector(selectSelectedLeagueId);
  const league = useAppSelector(selectSelectedLeague);
  return (
    <div className="lh main-middle-content-wrap">
      <main className="wrap main">
        <LeagueMatches leagueId={leagueId} leagueName={league?.leagueName} />
        <LeaguePointsTable leagueId={leagueId} />
        <LeagueStats leagueId={leagueId} />
      </main>
    </div>
  );
};

export default HomePage;
